export default {
  AUTHORITY_NONE: 0,
  AUTHORITY_EDITING_TESTER: 1,
  AUTHORITY_MANAGER: 2,
  AUTHORITY_TESTER: 3,
  AUTHORITY_EDITOR: 4,
  AUTHORITY_PUBLISHER: 5,
}